import { initReveals, initImageReveals, initPageEnter } from './reveals'
import { initSmoothScroll } from './scroll'
import { initPageTransitions } from './transitions'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export const prefersReducedMotion = () =>
	window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches

export const refreshMotion = () => {
	ScrollTrigger.getAll().forEach( (trigger) => trigger.kill() )
	initReveals()
	ScrollTrigger.refresh()
}

export const initMotion = () => {
	if ( prefersReducedMotion() ) {
		document.documentElement.classList.add( 'reduced-motion' )
		return
	}

	document.documentElement.classList.add( 'has-smooth-scroll' )
	initSmoothScroll()
	initReveals()
	initPageEnter()
	initPageTransitions()
}
